<template>
  <div>
    <div
      class="content-devx no-shadow content-dx-daily-planning content-block-table"
    >
      <DxDataGrid
        id="machineryTable"
        ref="machineryTable"
        :data-source="items.values"
        :column-min-width="70"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="false"
        :row-alternation-enabled="true"
        @row-inserted="onInsertedRow"
        @row-updated="onChangeRow"
        @row-removed="onRemovedRow"
      >
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="DxMachineryTable"
        />
        <DxExport
          :enabled="false"
        />
        <DxPaging :page-size="18" />
        <DxEditing
          :allow-updating="true"
          :allow-deleting="true"
          :allow-adding="true"
          mode="row"
        />
        <DxSearchPanel
          :visible="true"
          :width="100"
          :placeholder="$t('Search_placeholder')"
        />
        <DxColumn
          data-field="type"
          name="type"
          :caption="$t('DxMachinery_dxColumn_TypeMachinery')"
        >
          <DxLookup
            :data-source="machinary"
            display-expr="name"
            value-expr="id"
          />
          <DxRequiredRule />
        </DxColumn>
        <DxColumn
          data-field="count"
          :width="70"
          name="count"
          data-type="number"
          :caption="$t('DxMachinery_dxColumn_QuantityMachinery')"
          :calculate-cell-value="setDefaultValue"
        >
          <DxRequiredRule />
          <DxRangeRule
            min="1"
            :message="$t('Rules_count_more_than_zero')"
          />
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxSearchPanel,
  DxExport,
  DxRequiredRule,
  DxLookup,
  DxStateStoring,
} from 'devextreme-vue/data-grid';
import {
  DxRangeRule,
} from 'devextreme-vue/validator';
import * as overlay from 'devextreme/ui/overlay';

export default {
  name: 'DxMachineryTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSearchPanel,
    DxExport,
    DxRequiredRule,
    DxLookup,
    DxStateStoring,
    DxRangeRule,
  },
  props: {
    machinary: { type: Array, default: () => [] },
    planning: { type: Object, default: null },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('PlanningManager', ['items']),
  },
  beforeMount() {
    overlay.baseZIndex(9999);
    if (this.planning == null) {
      this.setItems([]);
    } else {
      this.actualItems = this.planning.ItemsDetailTab;
      this.setItems(this.actualItems);
    }
  },
  methods: {
    setDefaultValue(e) {
      e.count = (typeof (e.count) === 'undefined') ? 1 : e.count;
      return e.count;
    },
    // SET DATA SOURCE TO PRODUCTS VUEX
    onChangeRow() {
      const arrayItems = this.$refs.machineryTable.instance.getDataSource().items();
      const newItems = this.items;
      newItems.values = [];
      for (let i = 0; i < arrayItems.length; i += 1) {
        newItems.values.push({ type: arrayItems[i].type, count: arrayItems[i].count });
      }
      this.setItems(newItems.values);
    },
    onInsertedRow() {
      const newItems = this.items;
      this.setItems(newItems.values);
    },
    onRemovedRow() {
      const newValues = this.items;
      this.setItems(newValues.values);
    },
    ...mapActions('PlanningManager', ['setItems']),
  },
};
</script>
